import { Country, Location } from './countries';
import { basicPlanIds } from './plan-country-mappings';

/**
 * Maps a Users location into a country code that we support plans-wise
 */
export const transformLocationIntoValidPlanCountryCode = (location: Location | null): Country => {
  const countryCode = (location?.countryCode?.toUpperCase() as Country) || 'US';

  // Make sure we have suitable support for this country code
  return basicPlanIds[countryCode] ? countryCode : 'US';
};
